var finansudd = finansudd || {};

finansudd.newslist = new function() {

	var self = this;

	this.initNews = function () {
		if ($("#news-list").length) {
			self.loadNews(1);
			self.changeFilter(1);
		}
		if ($("#news-slider").length) {
			self.loadNewsSlider(1);
		}
	}

	this.loadNews = function (page) {
	
		var yearValue = $("#news-filter-year").val();
        var monthValue = $("#news-filter-month").val();
        var isNewsArchive = $("#is-news-archive").val();
	
		var filterValues = JSON.stringify({
			"Year": yearValue,
			"Month": monthValue,
            "Page": page,
            "IsNewsArchive": isNewsArchive
		});

		$.ajax({
			url: "/settings/newslistview/",
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues,
			success: function(data) {
				var itemCount = $(data).siblings('.item-count').text();
				$('.ajax-filter .filter-count > span').html(itemCount);

				$("#news-list").html(data)
			
				self.paging();

				novicell.responsiveImages.init();
				
				//$('.loader').remove();
			},
			error: function (data, errorThrown) {
				console.log(errorThrown)
			}
		});
	}

	this.loadNewsSlider = function (page) {
		var subjectAreas = $(".news-wrapper").data("subjectarea");

		var subjectAreasArray = subjectAreas != undefined ? subjectAreas.split(",").clean("") : null;
	
		var filterValues = JSON.stringify({
			"Year": 0,
			"Month": 0,
			"Page": page,
			"maxItems": 3,
			"Mode": "slider",
			"SubjectAreas": subjectAreasArray
		});

		$.ajax({
			url: "/settings/newslistview/",
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues,
			success: function(data) {

				$("#news-slider").html(data)

				finansudd.slider.newsSlider($('#news-slider'));
				novicell.responsiveImages.init();
			},
			error: function (data, errorThrown) {
				console.log(errorThrown)
			}
		});
	}
	
	this.changeFilter = function (page) {
		$(".news-filter-select").change(function() {
		  self.loadNews(page);
		});
		
	}

	this.paging = function () {

		$(".pager").click(function (e) {
			e.preventDefault();
			self.loadNews($(this).data("page"));
			finansudd.scrollTo.scrollTarget('#news-list', 0);
		});

	}

	Array.prototype.clean = function (deleteValue) {
		for (var i = 0; i < this.length; i++) {
			if (this[i] == deleteValue) {
				this.splice(i, 1);
				i--;
			}
		}
		return this;
	};
}